import React, { Component, Fragment } from 'react'

import { Typography, DialogContent } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Grow from '@material-ui/core/Grow'

import IconButton from '@material-ui/core/IconButton'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

import CloseIcon from '@material-ui/icons/Close'

import styles from './BBKVKProductTemplate.module.css'
import Spinner from '../../../Spinner.js'

import BBVis from '../BBVis'

import { SplitPane } from 'react-collapse-pane'
import BBKVKFlexibleTextWidget from './BBKVKFlexibleTextWidget'
import Area from '../../../Area'

export default class WettenPanel extends Component {
  state = { data: null }

  handleClose = () => {
    this.props.onClose()
  }

  Transition = React.forwardRef(function Transition(props, ref) {
    return <Grow direction="up" ref={ref} {...props} unmountOnExit />
  })

  getData() {
    var me = this
    console.log('get data with product uri ' + this.props.uri, this.props)

    window.top.query(
      'select * where {<' + this.props.uri + '> ?a ?b}',
      function (data) {
        me.setState({ data: data })
      }
    )
  }

  render() {
    const { open } = this.props

    //let mode= this.props.mode||'';
    let fullWidth = true
    let maxWidth = 'xl'
    maxWidth = 'md'
    let title = this.props.title

    let fullScreen = this.props.fullScreen
    if (fullScreen != null) {
      if (fullScreen === 'true') fullScreen = true
      if (fullScreen === 'false') fullScreen = false
    }
    if (fullScreen) {
    } else {
    }

    if (this.props.config) {
      return (
        <Dialog
          fullScreen={fullScreen}
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open}
          TransitionComponent={this.Transition}
          onClose={this.handleClose}
          aria-labelledby="iets"
        >
          {fullScreen ? (
            <Fragment>
              <AppBar className={styles.appBar}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={this.handleClose}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography variant="h6" className={styles.title}>
                    {title}
                  </Typography>
                </Toolbar>
              </AppBar>
              <br></br>
              <br></br>
              <br></br>
              <Area {...this.props} />
            </Fragment>
          ) : (
            <Fragment>
              <DialogTitle id="customized-dialog-title">
                {title}{' '}
                <IconButton
                  className={styles.closeButton}
                  onClick={this.handleClose}
                >
                  {' '}
                  <CloseIcon />{' '}
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Area {...this.props} />
              </DialogContent>
            </Fragment>
          )}
        </Dialog>
      )
    }

    if (this.state.data == null) {
      this.getData()
      return (
        <Dialog
          fullScreen
          open={open}
          TransitionComponent={this.Transition}
          onClose={this.handleClose}
          aria-labelledby="iets"
        >
          <AppBar className={styles.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={this.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={styles.title}>
                relaties
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
            <ListItem key="test">
              <Spinner />
            </ListItem>
          </List>
        </Dialog>
      )
    }
    console.log('wetten panel met spinner', this.props.uri)
    var uri =
      'http://www.kvk.nl/innovatielab/ggwbv2/producten/2020/uittreksels#NV_BVKpe3'
    if (this.props.uri != null) {
      uri = this.props.uri
    }
    var bind = '  bind (<' + uri + '> as ?node)\r\n'

    var sparql =
      'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\r\n' +
      'select distinct ?node ?nodeLabel ?edge ?edgeLabel ?object ?objectLabel\r\n' +
      'where\r\n' +
      '{\r\n' +
      '    graph <http://www.kvk.nl/innovatielab/ggwbv2/producten/2020/uittreksels>\r\n' +
      '    {\r\n' +
      bind +
      '  . ?node ?edge ?object. bind (STRAFTER(STR(?edge),"#") as ?edgeLabel).' +
      '    ?node rdfs:label ?nodeLabel.\r\n' +
      '    }\r\n' +
      '  ?object rdfs:label ?objectLabel' +
      '}\r\n'

    var extendquery =
      'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\r\n' +
      'select distinct ?node ?nodeLabel ?edge ?edgeLabel ?object ?objectLabel\r\n' +
      '\r\n' +
      'where\r\n' +
      '{\r\n' +
      '   \r\n' +
      '  bind (<{{uri}}> as ?node)\r\n' +
      '      ?node ?edge ?object.\r\n' +
      '    filter (?edge not in(<http://opendata.stelselcatalogus.nl/stelselcatalogus/def#sectorregistratie>))\r\n' +
      '   \r\n' +
      '    ?node rdfs:label ?nodeLabel.\r\n' +
      '    optional {?edge rdfs:label ?edgeLabel1}\r\n' +
      '    bind (IF(BOUND(?edgeLabel1),?edgeLabel1,"onbekend") as ?edgeLabel)\r\n' +
      '    ?object rdfs:label ?objectLabel\r\n' +
      '}\r\n' +
      '\r\n'
    var props = this.props
    var state = this.state

    var query = 'select * where {<{{selection}}> ?a ?b}'
    return (
      <Dialog
        fullScreen
        open={open}
        TransitionComponent={this.Transition}
        onClose={this.handleClose}
        aria-labelledby="iets"
      >
        <AppBar className={styles.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={this.handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={styles.title}>
              wetten relaties
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogTitle id="simple-dialog-title">
          Extra informatie over de link
        </DialogTitle>
        <SplitPane split="vertical">
          <div className={styles.vpane}>
            <BBVis
              basequery={sparql}
              props2={props}
              extendquery={extendquery}
              publishVariable="selection"
            ></BBVis>
          </div>
          <div className={styles.vpane}>
            <BBKVKFlexibleTextWidget
              query={query}
              {...state}
              {...props}
            ></BBKVKFlexibleTextWidget>
          </div>
        </SplitPane>
      </Dialog>
    )
  }
}
